import api from './api';

const toolFlowService = {
  list:   (workspaceId, botId) => api.get(`/workspaces/${workspaceId}/tool-flows?botId=${botId}`),
  create: (workspaceId, botId, name) => api.post(`/workspaces/${workspaceId}/tool-flows`, { botId, name }),
  get:    (workspaceId, id) => api.get(`/workspaces/${workspaceId}/tool-flows/${id}`),
  update: (workspaceId, id, data) => api.put(`/workspaces/${workspaceId}/tool-flows/${id}`, data),
  remove: (workspaceId, id) => api.delete(`/workspaces/${workspaceId}/tool-flows/${id}`),
  toggle: (workspaceId, id, enabled) => api.patch(`/workspaces/${workspaceId}/tool-flows/${id}/toggle`, { enabled }),
};

export default toolFlowService;
